import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { db } from "../firebase/config";
import { useLocation, useNavigate } from "react-router-dom";

const useFetchDocument = (collectionName, documentID) => {
  const [document, setDocument] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const getDocument = async () => {
    const docRef = doc(db, collectionName, documentID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const obj = {
        id: documentID,
        ...docSnap.data(),
      };
      setDocument(obj);
    } else {
      toast.error("Product not found");
      if (location.pathname.includes("/product-details")) {
        navigate("/");
      } else {
        navigate("/404");
      }
    }
  };

  useEffect(() => {
    getDocument();
  }, []);

  return { document };
};

export default useFetchDocument;
